<template>
    <v-row no-gutters class="pb-2">
        <v-col cols="12">
            <dialogo-opciones-componente :dialogo-titulo="$t('proceso_constructivo')" :descripcion="$t('descrip')"
                                         min-width="800px">
                <template v-slot:titulo>
                    {{ $t('proceso_constructivo') }}
                    <v-tooltip bottom max-width="500">
                        <template v-slot:activator="{on}">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>En función del nuevo material a instalar y el revestimiento existente, la herramienta contemplará unas operaciones de rehabilitación u otras</span>
                    </v-tooltip>
                    <v-icon v-if="procesoConstructivoCorrecto()" color="green">mdi-check</v-icon>
                    <v-icon v-if="!procesoConstructivoCorrecto()" color="red">mdi-close</v-icon>
                </template>

                <template v-slot:[slot.nombre] v-for="(slot,i) in slots">
                    <proceso-constructivo
                        tipo="horizontal"
                        v-model="slot.correcto"
                        :key="i"
                        :solucion-constructiva="proyecto.solucionesConstructivas[i]"
                        :proyecto-id="proyecto.id"
                        :escenario="proyecto.escenario"
                    >
                    </proceso-constructivo>
                </template>
            </dialogo-opciones-componente>
        </v-col>
    </v-row>
</template>

<script>
    import DialogoOpcionesComponente from "../../Componentes/DialogoOpcionesComponente";
    import ProcesoConstructivo from "../Componentes/ProcesoConstructivo";

    export default {
        name: "SolucionConstructivaHorizontalRehabilitacion",
        model: {
            prop: 'correct',
            event: 'change'
        },
        props: {
            proyecto: {type: Object, required: true},
            correct: {type: Boolean, default: false}
        },
        components: {
            DialogoOpcionesComponente,
            ProcesoConstructivo
        },
        data: function () {
            return {
                slots: [
                    {
                        nombre: "opcion1",
                        correcto: false
                    },
                    {
                        nombre: "opcion2",
                        correcto: false
                    }
                ]
            }
        },
        watch: {
            slots: {
                handler() {
                    this.emitirCorrecto(this.procesoConstructivoCorrecto());
                },
                deep: true
            }
        },
        methods: {
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            procesoConstructivoCorrecto() {
                if (!this.slots) return false;
                let correcto = true;
                this.slots.forEach((slot) => {
                    if (!slot.correcto) correcto = false;
                });

                return correcto;
            }
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "proceso_constructivo": "Proceso constructivo",
    "descrip": "Es el proceso constructivo"
    }
    }
</i18n>
<!--@formatter:on-->